import { browserHistory } from 'react-router';
import Helpers from "../.././dev/helpers/helperFunctions";
import gamesUrlFromHelpers from "../.././dev/helpers/creationGamesUrl";
import {t} from "../helpers/translator";
import {OpenPopup} from "../actions/ui";
import {VerifyUserByEmail} from "../actions/user";

let routeHelper = (hashParams, self) => {
    switch (hashParams.action) {
        case "register":
            !Helpers.CheckIfPathExists(self, "props.user.reallyLoggedIn") && setTimeout(() => {
                self.props.dispatch(OpenPopup("RegistrationForm", hashParams));
            });
            break;
        case "login":
            !self.props.user.reallyLoggedIn && setTimeout(() => {
                self.props.dispatch(OpenPopup("LoginForm", hashParams));
            });
            break;
        case "reset_password":
            setTimeout(() => {
                self.props.dispatch(OpenPopup("ResetPasswordForm", hashParams));
            });
            break;
        case "verify":
            setTimeout(() => {
                self.props.dispatch(VerifyUserByEmail({
                    successCallback: () => self.props.dispatch(OpenPopup("message", {
                        title: t("E-Mail Confirmation"),
                        type: "accept",
                        body: t("Your E-mail Has been confirmed")
                    })),
                    errorCallback: () => self.props.dispatch(OpenPopup("message", {
                        title: t("E-Mail Confirmation"),
                        type: "error",
                        body: t("Error")
                    })),
                    params: hashParams
                }));
            });
            break;
        default:
            break;
    }
    switch (true) {
        case hashParams.hasOwnProperty("sport") && (window.location.hash || "").includes("type=0"):
            hashParams.hasOwnProperty("game")
                    ? browserHistory.push("/prematch/game/" + hashParams.game)
                    : browserHistory.push(hashParams.sport && /^\w+$/.test(hashParams.sport)
                    ? "/prematch/" + hashParams.sport
                    : "/prematch");
            break;
        case hashParams.hasOwnProperty("sport") && (window.location.hash || "").includes("type=1"):
            hashParams.hasOwnProperty("game")
                    ? browserHistory.push("/live/game/" + hashParams.game)
                    : browserHistory.push(hashParams.sport && /^\w+$/.test(hashParams.sport)
                    ? "/live/" + hashParams.sport
                    : "/live");
            break;
        case hashParams.hasOwnProperty("casino"):
            browserHistory.push("/casino");
            break;
        case hashParams.hasOwnProperty("livedealer"):
            browserHistory.push("/live-casino");
            break;
        case hashParams.hasOwnProperty("promos"):
            Helpers.getUriParam("news") ? browserHistory.push("/promotions/#/id=" + Helpers.getUriParam("news")) : '';
            break;
        case hashParams.hasOwnProperty('tournaments'):
            browserHistory.push("/casino/tournaments/" + (Helpers.getUriParam("tournament_id") ? Helpers.getUriParam("tournament_id") : ""));
            break;
        case hashParams.hasOwnProperty('poker'):
        case Helpers.getUriParam("game") === '5639':
            browserHistory.push("/poker");
            break;
        case Helpers.getUriParam("game") === '547':
            window.open(gamesUrlFromHelpers.processingGamesUrl().beloteUrl, '_self');
            break;
        case Helpers.getUriParam("game") === '599':
            window.open(gamesUrlFromHelpers.processingGamesUrl().backgammonUrl, '_self');
            break;
        default:
            break;
    }
};
export default routeHelper;